export const ru = {
  seeAll: 'Посмотреть все',
};
